import React, { useState } from "react";
import pdf from "../../plateform/assets/icons/pdf-svgrepo-com (1).svg"
import word from "../../plateform/assets/icons/word-svgrepo-com.svg"

const FilePicker = ({ initialFile, handleChange ,onFileChange, label = "" , name="file"}) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      if (onFileChange) {
        onFileChange({ target: { name: "file", value: file } });
      }

      if(handleChange){
        handleChange(e)
      }
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    if (onFileChange) {
      onFileChange({ target: { name: "file", value: null } });
    }
  };

  const displayFileName = selectedFile ? selectedFile.name : initialFile;

  const getFileIcon = (fileName) => {
    if (!fileName) return null;

    const extension = fileName.split(".").pop().toLowerCase();
    if (extension === "pdf") {
      return <img src={pdf} alt="pdf" className="size-10"/>;
    } else if (["doc", "docx"].includes(extension)) {
      return  <img src={word} alt="pdf" className="size-10"/>;
    } else {
      return <span className="text-gray-600">📁 Fichier</span>;
    }
  };

  return (
    <div className="border-line p-4">
      <label
        htmlFor="file"
        className="text-sm font-medium text-gray-700 mb-1 text-start flex justify-start"
      >
        {label}
      </label>
      <div className="relative bg-primary-beige flex text-gray-400 border border-gray-300 border-dashed rounded cursor-pointer p-4">
        <input
          name={name}
          type="file"
          accept=".pdf,.doc,.docx"
          className="absolute inset-0 z-50 w-full h-full p-0 m-0 outline-none opacity-0 cursor-pointer"
          onChange={handleFileChange}
        />
        <div className="flex p-4 items-center justify- text-center gap-x-4 w-full">
          {selectedFile || initialFile ? (
             <div className="flex items-center justify-between w-full ">
                <div className="flex items-center gap-x-2">
                {getFileIcon(displayFileName)}
                <span className="text-sm font-medium text-primary-black">{displayFileName}</span> 
                </div>

                {(selectedFile || initialFile) && (
                    <div className="">
                        <label htmlFor="file" className="bg-primary-green text-emerald-700  px-4 py-2 rounded hover:bg-gray-600 cursor-pointer">
                            Modifier
                        </label>
                    </div>
                )}
            </div>
            
          ) : (
            <>
            <div className="bg-primary-green flex items-center justify-center p-2 text-primary rounded-full">
                        <svg width="25x" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.94 20.74C7.45715 20.7458 6.02743 20.1882 4.94001 19.18C4.41043 18.6904 3.98787 18.0965 3.69887 17.4356C3.40987 16.7748 3.26068 16.0613 3.26068 15.34C3.26068 14.6188 3.40987 13.9053 3.69887 13.2445C3.98787 12.5836 4.41043 11.9897 4.94001 11.5L12.5 4.36005C13.2775 3.65032 14.2923 3.25684 15.345 3.25684C16.3977 3.25684 17.4125 3.65032 18.19 4.36005C18.5954 4.73639 18.9204 5.19087 19.1456 5.69612C19.3707 6.20138 19.4913 6.74697 19.5 7.30005C19.5027 7.77802 19.4064 8.25137 19.2171 8.69025C19.0278 9.12914 18.7495 9.52404 18.4 9.85005L10.83 17C10.3732 17.4239 9.77312 17.6594 9.15 17.6594C8.52689 17.6594 7.92679 17.4239 7.47001 17C7.24334 16.7912 7.06243 16.5376 6.93869 16.2554C6.81495 15.9731 6.75106 15.6682 6.75106 15.36C6.75106 15.0518 6.81495 14.747 6.93869 14.4647C7.06243 14.1824 7.24334 13.9289 7.47001 13.72L14.47 7.13005C14.6106 6.9896 14.8013 6.91071 15 6.91071C15.1988 6.91071 15.3894 6.9896 15.53 7.13005C15.6705 7.27067 15.7493 7.4613 15.7493 7.66005C15.7493 7.8588 15.6705 8.04942 15.53 8.19005L8.53 14.78C8.45149 14.8486 8.38856 14.9331 8.34544 15.028C8.30232 15.1228 8.28 15.2258 8.28 15.33C8.28 15.4343 8.30232 15.5373 8.34544 15.6321C8.38856 15.727 8.45149 15.8115 8.53 15.88C8.71114 16.035 8.94165 16.1201 9.18001 16.1201C9.41836 16.1201 9.64887 16.035 9.83001 15.88L17.4 8.75005C17.5926 8.56129 17.745 8.33553 17.8482 8.08635C17.9513 7.83717 18.0029 7.56971 18 7.30005C17.9917 6.95248 17.913 6.6102 17.7686 6.29393C17.6242 5.97767 17.4172 5.69398 17.16 5.46005C16.6663 5.0025 16.0181 4.74828 15.345 4.74828C14.6719 4.74828 14.0237 5.0025 13.53 5.46005L6.00001 12.59C5.61867 12.9395 5.31419 13.3644 5.10588 13.8378C4.89757 14.3113 4.79001 14.8228 4.79001 15.34C4.79001 15.8573 4.89757 16.3688 5.10588 16.8423C5.31419 17.3157 5.61867 17.7406 6.00001 18.09C6.81452 18.8492 7.88656 19.2714 9.00001 19.2714C10.1135 19.2714 11.1855 18.8492 12 18.09L19.49 11C19.559 10.9293 19.6414 10.8731 19.7324 10.8347C19.8234 10.7963 19.9212 10.7765 20.02 10.7765C20.1188 10.7765 20.2166 10.7963 20.3076 10.8347C20.3986 10.8731 20.4811 10.9293 20.55 11C20.6905 11.1407 20.7693 11.3313 20.7693 11.53C20.7693 11.7288 20.6905 11.9194 20.55 12.06L13 19.18C11.898 20.2034 10.4437 20.7622 8.94 20.74Z" fill="#000000"/>
                        </svg>
                        </div>
                        <p className="m-0 text-primary-black">
             Glissez le fichier ici ou cliquez pour sélectionner.
            </p>
          
            </>
        )}
        </div>
        
      </div>
      <p className="text-start mt-2 text-sm">
        Veuillez joindre un fichier au format PDF ou Word (taille max : 5 Mo).
      </p>
    
    </div>
  );
};

export default FilePicker;
